import { IReturnHTTP } from "@fl/shared/src/types/returns";
import axios, { AxiosRequestConfig } from "axios";
import { generateMessageReturn } from "../utils/messageFuncs";

export type httpMethods = "get" | "post" | "put" | "delete";

class RequestAPI {
  baseUrl: string;
  protected result: IReturnHTTP = {
    data: null,
    message: undefined,
    success: false,
  };
  constructor(baseUrl: string = process.env.REACT_APP_API_URL || "/api") {
    // remove barra no final se tiver, pra evitar "//"
    this.baseUrl = baseUrl.replace(/\/$/, "");
  }

  send = async (method: httpMethods, headers?: object, data?: any) => {
    var config: AxiosRequestConfig = {
      method: method,
      url: this.baseUrl,
    };

    if (headers) config.headers = headers;
    if (data) config.data = data;

    this.result = await axios(config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn("Erro: Request API", error.message, "danger"),
          ];
          return this.result;
        }
      });

    return this.result;
  };
}

export default RequestAPI;
